<template>
  <base-list-item class="scs-contact-location-event-list-item">
    <contact-name-and-photo
      class="event-list-item-section"
      :contact="primaryContact"
    />
    <location-details-simple
      class="event-list-item-section location-details"
      :location="primaryLocation"
    />
    <right-aligned-event-details
      class="event-list-item-section"
      :event="event"
      :requests="[
        'balance-outstanding',
        'formatted-date',
        'formatted-start-and-end',
      ]"
    />
  </base-list-item>
</template>
<script>
import BaseListItem from "../BaseListItem.vue";
import LocationDetailsSimple from "../ListItemComponents/LocationDetailsSimple.vue";
import ContactNameAndPhoto from "../ListItemComponents/ContactNameAndPhoto.vue";
import RightAlignedEventDetails from "../ListItemComponents/RightAlignedEventDetails.vue";
export default {
  computed: {
    primaryContact() {
      return this.event.contacts[0];
    },
    primaryLocation() {
      return this.event.locations[0];
    },
  },
  components: {
    BaseListItem,
    ContactNameAndPhoto,
    LocationDetailsSimple,
    RightAlignedEventDetails,
  },
  props: ["event"],
};
</script>
<style scoped>
.scs-contact-location-event-list-item {
  height: 50px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.event-list-item-section {
  max-width: 30%;
  width: 30%;
}

@media screen {
  @media (max-width: 800px) {
    .location-details {
      display: none;
    }
    .event-list-item-section {
      max-width: 50%;
      width: 50%;
    }
  }
}
</style>
